import { defineMessage, defineMessages } from "react-intl";
import { defaultCrudMessages } from "../shared/crud/simple-crud";

export const reservationMessages: {
  [key: string]: { id: string; defaultMessage: string };
} = defineMessages({
  alertError: {
    id: "reservations.alert.error",
    defaultMessage: "Error",
  },
  alertWarning: {
    id: "reservations.alert.warning",
    defaultMessage: "Advertencia",
  },
  alertTitleInfo: {
    id: "reservations.alert.information",
    defaultMessage: "Información",
  },
  alertInfoText: {
    id: "reservations.alert.information.text",
    defaultMessage: "Danos un momento estamos consultado la información",
  },
  alertWarningText: {
    id: "reservations.alert.warning.text",
    defaultMessage: "Hemos tenido un problemas, intentalo mas tarde.",
  },
  alertSucces: {
    id: "reservations.alert.succes",
    defaultMessage: "Exito",
  },
  alertSuccesText: {
    id: "reservations.alert.succes.text",
    defaultMessage: "Los datos de la tarjeta se podrán ver durante 2 minutos haciendo click en",
  },
  alertSuccesTextConsult: {
    id: "reservations.alert.succes.textConsult",
    defaultMessage: "Consultar",
  },
  alertSuccesTextBack: {
    id: "reservations.alert.succes.textBack",
    defaultMessage: "Volver",
  },
  emailConfirmation: {
    id: "reservations.emailConfirmation",
    defaultMessage: "Are you sure?",
  },
  cancellationConfirmation: {
    id: "reservations.cancellationConfirmation",
    defaultMessage: "Are you sure?",
  },
  confirmationConfirmation: {
    id: "reservations.confirmationConfirmation",
    defaultMessage: "Are you sure?",
  },
  legendFailed: {
    id: "reservations.legendFailed",
    defaultMessage: "legendFailed",
  },
  legendSuccess: {
    id: "reservations.legendSuccess",
    defaultMessage: "legendSuccess",
  },
  legendAbandoned: {
    id: "reservations.legendAbandoned",
    defaultMessage: "legendAbandoned",
  },
  legendAwaiting: {
    id: "reservations.legendAwaiting",
    defaultMessage: "legendAwaiting",
  },
  legendTimedOut: {
    id: "reservations.legendTimedOut",
    defaultMessage: "legendTimedOut",
  },
  legendDiffered: {
    id: "reservations.legendDiffered",
    defaultMessage: "legendDiffered",
  },
  legendOnline: {
    id: "reservations.legendOnline",
    defaultMessage: "legendOnline",
  },
  edit: {
    id: "reservations.tooltipEdit",
    defaultMessage: "edit",
  },
  historical: {
    id: "reservations.tooltipHistorical",
    defaultMessage: "historical",
  },
  detail: {
    id: "reservations.tooltipDetail",
    defaultMessage: "detail",
  },
  cancel: {
    id: "reservations.tooltipCancel",
    defaultMessage: "cancel",
  },
  confirm: {
    id: "reservations.tooltipConfirm",
    defaultMessage: "confirm",
  },
  reactivate: {
    id: "reservations.tooltipReactivate",
    defaultMessage: "reactivate",
  },
  emailResend: {
    id: "reservations.emailResend",
    defaultMessage: "emailResend",
  },
  showCC: {
    id: "reservations.tooltipShowCC",
    defaultMessage: "show CC",
  },
  cardSent: {
    id: "reservations.cardSent",
    defaultMessage: "The credit card has been sent to the channel manager",
  },
  yes: {
    id: "default.yes",
    defaultMessage: "yes",
  },
  no: {
    id: "default.no",
    defaultMessage: "no",
  },
  hasComments: {
    id: "default.hasComments",
    defaultMessage: "Has comments?",
  },
  hasInternalNotes: {
    id: "default.hasInternalNotes",
    defaultMessage: "Has internal note?",
  },
  onlineStoreOrderId: {
    id: "reservations.onlineStoreOrderId",
    defaultMessage: "Online store ID",
  },
  AGENCY: {
    id: "reservations.agency",
    defaultMessage: "agency",
  },
  COMPANY: {
    id: "reservations.company",
    defaultMessage: "company",
  },
  NO_ORGANIZATION: {
    id: "reservations.individuals",
    defaultMessage: "individuals",
  },
  tcgarantia: {
    id: "reservations.tcgarantia",
    defaultMessage: "tcgarantia",
  },
  cc_vault: {
    id: "reservations.cc_vault",
    defaultMessage: "CC Guarantee",
  },
  tpv: {
    id: "reservations.tpv",
    defaultMessage: "tpv",
  },
  tr: {
    id: "reservations.tr",
    defaultMessage: "WIRE",
  },
  ext_storage: {
    id: "reservations.ext_storage",
    defaultMessage: "ext_storage",
  },
  tctoken: {
    id: "reservations.tctoken",
    defaultMessage: "TOK",
  },
  tpvtoken: {
    id: "reservations.tpvtoken",
    defaultMessage: "TOK",
  },
  paypal_ec: {
    id: "reservations.paypal_ec",
    defaultMessage: "Paypal",
  },
  paypal_std: {
    id: "reservations.paypal_std",
    defaultMessage: "Paypal",
  },
  mp: {
    id: "reservations.mp",
    defaultMessage: "mp",
  },
  stripe: {
    id: "reservations.stripe",
    defaultMessage: "stripe",
  },
  cc_vaultemg: {
    id: "reservations.cc_vaultemg",
    defaultMessage: "cc_vaultemg",
  },
  pci_proxy: {
    id: "reservations.pci_proxy",
    defaultMessage: "pci_proxy",
  },
  addon_payments: {
    id: "reservations.addon_payments",
    defaultMessage: "addon_payments",
  },
  adyen: {
    id: "reservations.adyen",
    defaultMessage: "adyen",
  },
  pay_no_pain_v2: {
    id: "reservations.pay_no_pain_v2",
    defaultMessage: "PayNoPain_v2",
  },
  pay_no_pain_proxy: {
    id: "reservations.pay_no_pain_proxy",
    defaultMessage: "CC Guarantee (PCI)",
  },
  without_card: {
    id: "reservations.without_card",
    defaultMessage: "No Card",
  },
  reservation_request: {
    id: "reservations.reservation_request",
    defaultMessage: "Reservation Request",
  },
  pos: {
    id: "reservations.pos",
    defaultMessage: "POS",
  },
  criptan: {
    id: "reservations.criptan",
    defaultMessage: "CRIPTAN",
  },
  deferred: {
    id: "reservations.deferred",
    defaultMessage: "Deferred",
  },
  tc_garantia_pci: {
    id: "reservations.tc_garantia_pci",
    defaultMessage: "CC Guarantee (PCI)",
  },
  credentialsModalTitle: {
    id: "reservations.credentials.modal.title",
    defaultMessage: "Enter credentials",
  },
  credentialsModalUsername: {
    id: "reservations.credentials.modal.username",
    defaultMessage: "Username",
  },
  credentialsModalPassword: {
    id: "reservations.credentials.modal.password",
    defaultMessage: "Password",
  },
  credentialsModalInvalidUser: {
    id: "reservations.credentials.modal.invalidUser",
    defaultMessage: "Invalid user",
  },
  delayedEdit: {
    id: "reservations.edit.delayed",
    defaultMessage: "Try again in 5 minutes. Editing is not available at the moment.",
  },
  noShowFilter: {
    id: "reservations.noShowFilter",
    defaultMessage: "No show?",
  },
  noShow: {
    id: "reservations.tooltipNoShow",
    defaultMessage: "No show",
  },
  show: {
    id: "reservations.tooltipShowed",
    defaultMessage: "Showed",
  },
  markAsNoShow: {
    id: "reservations.markAsNoShow",
    defaultMessage: "The booking will be marked as no show",
  },
  markAsShowed: {
    id: "reservations.markAsShowed",
    defaultMessage: "The booking will be marked as show",
  },
  doYouWantToContinue: {
    id: "reservations.noShowContinue",
    defaultMessage: "Do you want to continue?",
  },
  TCG: {
    id: "reservations.filter.paymentType.TCG",
    defaultMessage: "CC Guarantee",
  },
  TCG_PCI: {
    id: "reservations.filter.paymentType.TCG_PCI",
    defaultMessage: "CC Guarantee (PCI)",
  },
  TPV: {
    id: "reservations.filter.paymentType.TPV",
    defaultMessage: "POS",
  },
  TRS: {
    id: "reservations.filter.paymentType.TRS",
    defaultMessage: "WIRE",
  },
  NO_CARD: {
    id: "reservations.filter.paymentType.NO_CARD",
    defaultMessage: "No Card",
  },
  RESERVATION_REQUEST: {
    id: "reservations.filter.paymentType.RESERVATION_REQUEST",
    defaultMessage: "Reservation request",
  },
  TOK: {
    id: "reservations.filter.paymentType.TOK",
    defaultMessage: "TOK",
  },
  PAYPAL: {
    id: "reservations.filter.paymentType.PAYPAL",
    defaultMessage: "PAYPAL",
  },
  DEFERRED: {
    id: "reservations.filter.paymentType.DEFERRED",
    defaultMessage: "Deferred",
  },
  CRIPTAN: {
    id: "reservations.filter.paymentType.CRIPTAN",
    defaultMessage: "CRIPTAN",
  },
  PAYNOPAIN_V2: {
    id: "reservations.filter.paymentType.PAYNOPAIN_V2",
    defaultMessage: "PayNoPain_v2",
  },
  pnp_PayNoPain_v3: {
    id: "reservations.filter.paymentType.pnp_PayNoPain_v3",
    defaultMessage: "pnp_PayNoPain_v3",
  },
  pnp_TC: {
    id: "reservations.filter.paymentType.pnp_TC",
    defaultMessage: "pnp_TC",
  },
  pnp_Bizum: {
    id: "reservations.filter.paymentType.pnp_Bizum",
    defaultMessage: "pnp_Bizum",
  },
  pnp_Sofort: {
    id: "reservations.filter.paymentType.pnp_Sofort",
    defaultMessage: "pnp_Sofort",
  },
  pnp_Ideal: {
    id: "reservations.filter.paymentType.pnp_Ideal",
    defaultMessage: "pnp_iDeal",
  },
  pnp_Crypto: {
    id: "reservations.filter.paymentType.pnp_Crypto",
    defaultMessage: "pnp_Crypto",
  },
  pnp_PIX: {
    id: "reservations.filter.paymentType.pnp_PIX",
    defaultMessage: "pnp_PIX",
  },
  pnp_ViaCash: {
    id: "reservations.filter.paymentType.pnp_ViaCash",
    defaultMessage: "pnp_ViaCash",
  },
  pnp_Klarna: {
    id: "reservations.filter.paymentType.pnp_Klarna",
    defaultMessage: "pnp_Klarna",
  },
  pnp_GiroPay: {
    id: "reservations.filter.paymentType.pnp_GiroPay",
    defaultMessage: "pnp_GiroPay",
  },
  pnp_GooglePay: {
    id: "reservations.filter.paymentType.pnp_GooglePay",
    defaultMessage: "pnp_GooglePay",
  },
  pnp_ApplePay: {
    id: "reservations.filter.paymentType.pnp_ApplePay",
    defaultMessage: "pnp_ApplePay",
  },
  pnp_C2P: {
    id: "reservations.filter.paymentType.pnp_C2P",
    defaultMessage: "pnp_C2P",
  },
  pnp_MercadoPago: {
    id: "reservations.filter.paymentType.pnp_MercadoPago",
    defaultMessage: "pnp_MercadoPago",
  },
  pcomet_TC: {
    id: "reservations.filter.paymentType.pcomet_TC",
    defaultMessage: "pcomet_TC",
  },
  pcomet_Bizum: {
    id: "reservations.filter.paymentType.pcomet_Bizum",
    defaultMessage: "pcomet_Bizum",
  },
  pcomet_Paypal: {
    id: "reservations.filter.paymentType.pcomet_Paypal",
    defaultMessage: "pcomet_Paypal",
  },
  pcomet_Ideal: {
    id: "reservations.filter.paymentType.pcomet_Ideal",
    defaultMessage: "pcomet_iDeal",
  },
  pcomet_Klarna: {
    id: "reservations.filter.paymentType.pcomet_Klarna",
    defaultMessage: "pcomet_Klarna",
  },
  pcomet_GiroPay: {
    id: "reservations.filter.paymentType.pcomet_GiroPay",
    defaultMessage: "pcomet_GiroPay",
  },
  pcomet_Sofort: {
    id: "reservations.filter.paymentType.pcomet_Sofort",
    defaultMessage: "pcomet_Sofort",
  },
  pcomet_GooglePay: {
    id: "reservations.filter.paymentType.pcomet_GooglePay",
    defaultMessage: "pcomet_GooglePay",
  },
  pcomet_ApplePay: {
    id: "reservations.filter.paymentType.pcomet_ApplePay",
    defaultMessage: "pcomet_ApplePay",
  },
  pcomet_IVR: {
    id: "reservations.filter.paymentType.pcomet_IVR",
    defaultMessage: "pcomet_IVR",
  },
  addon_pay_TC: {
    id: "reservations.filter.paymentType.addon_pay_TC",
    defaultMessage: "addon_pay_TC",
  },
  adyen_TC: {
    id: "reservations.filter.paymentType.adyen_TC",
    defaultMessage: "adyen_TC",
  },
  adyen_GooglePay: {
    id: "reservations.filter.paymentType.adyen_GooglePay",
    defaultMessage: "adyen_GooglePay",
  },
  adyen_ApplePay: {
    id: "reservations.filter.paymentType.adyen_ApplePay",
    defaultMessage: "adyen_ApplePay",
  },
  stripe_CreditCard: {
    id: "reservations.filter.paymentType.stripe_CreditCard",
    defaultMessage: "Stripe_CreditCard",
  },
  stripe_GooglePay: {
    id: "reservations.filter.paymentType.stripe_GooglePay",
    defaultMessage: "Stripe_GooglePay",
  },
  stripe_ApplePay: {
    id: "reservations.filter.paymentType.stripe_ApplePay",
    defaultMessage: "Stripe_ApplePay",
  },
  stripe_Klarna: {
    id: "reservations.filter.paymentType.stripe_Klarna",
    defaultMessage: "Stripe_Klarna",
  },
  stripe_Link: {
    id: "reservations.filter.paymentType.stripe_Link",
    defaultMessage: "Stripe_Link",
  },
  freedompay_CreditCard: {
    id: "reservations.filter.paymentType.freedompay_CreditCard",
    defaultMessage: "Freedompay_CreditCard",
  },
  freedompay_GooglePay: {
    id: "reservations.filter.paymentType.freedompay_GooglePay",
    defaultMessage: "Freedompay_GooglePay",
  },
  nemuru_Sequra: {
    id: "reservations.filter.paymentType.nemuru_Sequra",
    defaultMessage: "Nemuru_Sequra",
  },
  nemuru_Aplazame: {
    id: "reservations.filter.paymentType.nemuru_Aplazame",
    defaultMessage: "Nemuru_Aplazame",
  },
  nemuru_Pepper: {
    id: "reservations.filter.paymentType.nemuru_Pepper",
    defaultMessage: "Nemuru_Pepper",
  },
  nemuru_Floa: {
    id: "reservations.filter.paymentType.nemuru_Floa",
    defaultMessage: "Nemuru_Floa",
  },
  willReceiveEmail: {
    id: "reservations.alert.success.willReceiveEmail",
    defaultMessage: "You will receive an email at {email} with the link to access card details.",
  },
  hasCommunicationConsent: {
    id: "default.hasCommunicationConsent",
    defaultMessage: "Has emailing?",
  },
  exportUnmaskedReservationsBtn: {
    id: "reservations.btn.label.exportUnmaskedReservations",
    defaultMessage: "Export unmasked results",
  },
  sendUnmaskedReservationTooltip: {
    id: "reservations.tooltip.sendUnmaskedReservation",
    defaultMessage: "Send unmasked reservation by email",
  },
  sendUnmaskedListEmailSuccess: {
    id: "reservations.alert.success.sendUnmaskedListEmail",
    defaultMessage: "You will receive an email at {email} with the reservation list attached",
  },
  sendUnmaskedListEmailError: {
    id: "reservations.alert.error.sendUnmaskedListEmail",
    defaultMessage: "An error occurred trying to send unmasked reservation list by email",
  },
  sendUnmaskedReservationEmailSuccess: {
    id: "reservations.alert.success.sendUnmaskedReservationEmail",
    defaultMessage: "You will receive an email at {email} with the reservation info",
  },
  sendUnmaskedReservationEmailError: {
    id: "reservations.alert.error.sendUnmaskedReservationEmail",
    defaultMessage: "An error occurred trying to send unmasked reservation by email",
  },
  unmaskedErrorTooManyRequests: {
    id: "reservations.alert.error.unmaskedErrorTooManyRequests",
    defaultMessage:
      "You've reached the maximum unmasked requests by minute. Please, try again later.",
  },
});

export const reservationCrudMessages = {
  ...defaultCrudMessages,
  tableHeaders: {
    propertyId: defineMessage({
      id: "reservations.propertyId",
      defaultMessage: "propertyId",
    }),
    bookingId: defineMessage({ id: "reservations.bookingId", defaultMessage: "bookingId" }),
    multipleBookingId: defineMessage({
      id: "reservations.multipleBookingId",
      defaultMessage: "multipleBookingId",
    }),
    bookingDate: defineMessage({ id: "reservations.bookingDate", defaultMessage: "bookingDate" }),
    checkin: defineMessage({ id: "reservations.checkin", defaultMessage: "checkin" }),
    checkout: defineMessage({ id: "reservations.checkout", defaultMessage: "checkout" }),
    rooms: defineMessage({ id: "reservations.rooms", defaultMessage: "rooms" }),
    totalAmount: defineMessage({ id: "reservations.totalAmount", defaultMessage: "totalAmount" }),
    guaranteeAmount: defineMessage({
      id: "reservations.guaranteeAmount",
      defaultMessage: "guaranteeAmount",
    }),
    currency: defineMessage({ id: "reservations.currency", defaultMessage: "currency" }),
    status: defineMessage({ id: "reservations.status", defaultMessage: "status" }),
    paymentType: defineMessage({ id: "reservations.paymentType", defaultMessage: "paymentType" }),
    paymentStatus: defineMessage({
      id: "reservations.paymentStatus",
      defaultMessage: "paymentStatus",
    }),
    lastModificationDate: defineMessage({
      id: "reservations.lastModificationDate",
      defaultMessage: "lastModificationDate",
    }),
    nights: defineMessage({ id: "reservations.nights", defaultMessage: "nights" }),
    inventoryTicker: defineMessage({
      id: "reservations.inventoryTicker",
      defaultMessage: "inventoryTicker",
    }),
    bundleTicker: defineMessage({
      id: "reservations.bundleTicker",
      defaultMessage: "Package",
    }),
    accommodationTicker: defineMessage({
      id: "reservations.accommodationTicker",
      defaultMessage: "accommodationTicker",
    }),
    configurationTicker: defineMessage({
      id: "reservations.configurationTicker",
      defaultMessage: "configurationTicker",
    }),
    mealPlanTicker: defineMessage({
      id: "reservations.mealPlanTicker",
      defaultMessage: "mealPlanTicker",
    }),
    conditionTicker: defineMessage({
      id: "reservations.conditionTicker",
      defaultMessage: "conditionTicker",
    }),
    capacity: defineMessage({ id: "reservations.capacity", defaultMessage: "capacity" }),
    advance: defineMessage({ id: "reservations.advance", defaultMessage: "advance" }),
    affiliate: defineMessage({ id: "reservations.affiliate", defaultMessage: "affiliate" }),
    userEmailStatus: defineMessage({
      id: "reservations.userEmailStatus",
      defaultMessage: "userEmailStatus",
    }),
    hotelEmailStatus: defineMessage({
      id: "reservations.hotelEmailStatus",
      defaultMessage: "hotelEmailStatus",
    }),
    extras: defineMessage({ id: "reservations.extras", defaultMessage: "extras" }),
    promotions: defineMessage({ id: "reservations.promotions", defaultMessage: "promotions" }),
    comments: defineMessage({ id: "reservations.comments", defaultMessage: "comments" }),
    internalNotes: defineMessage({
      id: "reservations.internalNotes",
      defaultMessage: "internalNotes",
    }),
    country: defineMessage({ id: "reservations.country", defaultMessage: "country" }),
    name: defineMessage({ id: "reservations.name", defaultMessage: "name" }),
    email: defineMessage({ id: "reservations.email", defaultMessage: "email" }),
    phone: defineMessage({ id: "reservations.phone", defaultMessage: "phone" }),
    roomNights: defineMessage({ id: "reservations.roomNights", defaultMessage: "roomNights" }),
    hasComments: defineMessage({ id: "default.hasComments", defaultMessage: "hasComments" }),
    hasInternalNotes: defineMessage({
      id: "default.hasInternalNotes",
      defaultMessage: "hasInternalNotes",
    }),
    noShowLabel: defineMessage({ id: "reservations.tooltipNoShow", defaultMessage: "No show" }),
    noShow: defineMessage({ id: "reservations.noShowFilter", defaultMessage: "No show?" }),
    isCombined: defineMessage({ id: "default.isCombined", defaultMessage: "isCombined" }),
    promoCode: defineMessage({ id: "reservations.promocode", defaultMessage: "promocode" }),
    tierTicker: defineMessage({ id: "reservations.tierTicker", defaultMessage: "Tier ticker" }),
    cancellationDate: defineMessage({
      id: "reservations.cancellationDate",
      defaultMessage: "cancellationDate",
    }),
    cancellationReason: defineMessage({
      id: "reservations.cancellationReason",
      defaultMessage: "cancellationReason",
    }),
    organizationName: defineMessage({
      id: "reservations.organizationName",
      defaultMessage: "organizationName",
    }),
    organizationType: defineMessage({
      id: "reservations.organizationType",
      defaultMessage: "organizationType",
    }),
    onlineStoreOrderId: defineMessage({
      id: "reservations.onlineStoreOrderId",
      defaultMessage: "onlineStoreOrderId",
    }),
    origin: defineMessage({
      id: "reservations.origin",
      defaultMessage: "Origin",
    }),
    mode: defineMessage({
      id: "reservations.mode",
      defaultMessage: "Mode",
    }),
    locale: defineMessage({
      id: "reservations.locale",
      defaultMessage: "Locale",
    }),
    communicationConsent: defineMessage({
      id: "reservations.communicationConsent",
      defaultMessage: "Emailing",
    }),
    tags: defineMessage({
      id: "reservations.featureTag",
      defaultMessage: "Feature Tag",
    }),
  },
  entityName: defineMessage({ id: "reservations.entityName", defaultMessage: "Reservations" }),
};
